import { render, staticRenderFns } from "./DisplayAPR.vue?vue&type=template&id=22f65388"
import script from "./DisplayAPR.vue?vue&type=script&lang=js"
export * from "./DisplayAPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports